export default __webpack_public_path__ + "static/media/P10021.eff4a1dd.png";